module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "login",
    attrs: {
      "onselectstart": "return false"
    }
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "login-container"
  }, [_c('div', {
    staticClass: "login-card"
  }, [_vm._m(1), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.log_in),
      expression: "log_in"
    }],
    staticClass: "form-area"
  }, [_c('div', {
    staticClass: "form-title"
  }, [_vm._v("欢迎回来")]), _vm._v(" "), _vm._l((_vm.loginData), function(item, index) {
    return _c('div', {
      staticClass: "input-group"
    }, [_c('div', {
      staticClass: "input-icon"
    }, [_c('img', {
      attrs: {
        "src": item.image
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "input-field"
    }, [(item.type == 'account') ? _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.login_input_account),
        expression: "login_input_account"
      }],
      attrs: {
        "list": "history",
        "type": "text",
        "placeholder": item.title
      },
      domProps: {
        "value": (_vm.login_input_account)
      },
      on: {
        "input": [function($event) {
          if ($event.target.composing) { return; }
          _vm.login_input_account = $event.target.value
        }, function($event) {
          return _vm.handleInputEditing(item)
        }]
      }
    }) : _vm._e(), _vm._v(" "), _c('datalist', {
      attrs: {
        "id": "history"
      }
    }, _vm._l((_vm.login_account_history), function(item, index) {
      return _c('option', [_vm._v(_vm._s(item))])
    }), 0), _vm._v(" "), ((_vm.password) === 'checkbox' && (item.type == 'password')) ? _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.login_input_password),
        expression: "login_input_password"
      }],
      attrs: {
        "placeholder": item.title,
        "type": "checkbox"
      },
      domProps: {
        "checked": Array.isArray(_vm.login_input_password) ? _vm._i(_vm.login_input_password, null) > -1 : (_vm.login_input_password)
      },
      on: {
        "input": function($event) {
          return _vm.handleInputEditing(item)
        },
        "change": function($event) {
          var $$a = _vm.login_input_password,
            $$el = $event.target,
            $$c = $$el.checked ? (true) : (false);
          if (Array.isArray($$a)) {
            var $$v = null,
              $$i = _vm._i($$a, $$v);
            if ($$el.checked) {
              $$i < 0 && (_vm.login_input_password = $$a.concat([$$v]))
            } else {
              $$i > -1 && (_vm.login_input_password = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
            }
          } else {
            _vm.login_input_password = $$c
          }
        }
      }
    }) : ((_vm.password) === 'radio' && (item.type == 'password')) ? _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.login_input_password),
        expression: "login_input_password"
      }],
      attrs: {
        "placeholder": item.title,
        "type": "radio"
      },
      domProps: {
        "checked": _vm._q(_vm.login_input_password, null)
      },
      on: {
        "input": function($event) {
          return _vm.handleInputEditing(item)
        },
        "change": function($event) {
          _vm.login_input_password = null
        }
      }
    }) : (item.type == 'password') ? _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.login_input_password),
        expression: "login_input_password"
      }],
      attrs: {
        "placeholder": item.title,
        "type": _vm.password
      },
      domProps: {
        "value": (_vm.login_input_password)
      },
      on: {
        "input": [function($event) {
          if ($event.target.composing) { return; }
          _vm.login_input_password = $event.target.value
        }, function($event) {
          return _vm.handleInputEditing(item)
        }]
      }
    }) : _vm._e()]), _vm._v(" "), (item.type == 'password') ? _c('div', {
      staticClass: "show-password",
      on: {
        "click": function($event) {
          return _vm.passwordSee()
        }
      }
    }, [_c('img', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (!_vm.showPassword),
        expression: "!showPassword"
      }],
      attrs: {
        "src": require("./register_nosee.png")
      }
    }), _vm._v(" "), _c('img', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.showPassword),
        expression: "showPassword"
      }],
      attrs: {
        "src": require("./register_see.png")
      }
    })]) : _vm._e()])
  }), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.log_in),
      expression: "log_in"
    }],
    staticClass: "forgot-password",
    on: {
      "click": function($event) {
        return _vm.forgotClick()
      }
    }
  }, [_vm._v("忘记密码?")]), _vm._v(" "), _c('div', {
    staticClass: "toast",
    class: {
      'success': _vm.toast_active
    }
  }, [_vm._v(_vm._s(_vm.error_info))]), _vm._v(" "), _c('button', {
    staticClass: "login-button",
    class: {
      'disabled': !_vm.login_normarl_status, 'active': _vm.login_normarl_status
    },
    on: {
      "click": function($event) {
        return _vm.handleLoginButton()
      }
    }
  }, [_vm._v(_vm._s(_vm.login_title))]), _vm._v(" "), _c('div', {
    staticClass: "register-link"
  }, [_c('span', [_vm._v(_vm._s(_vm.login_text_1))]), _vm._v(" "), _c('a', {
    on: {
      "click": function($event) {
        return _vm.handleText()
      }
    }
  }, [_vm._v(_vm._s(_vm.login_text_2))])])], 2), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.log_in_register),
      expression: "log_in_register"
    }],
    staticClass: "form-area"
  }, [_c('div', {
    staticClass: "form-title"
  }, [_vm._v(_vm._s(_vm.isForgotpwd ? '找回密码' : '创建账号'))]), _vm._v(" "), _vm._l((_vm.register_forgot_data), function(item, index) {
    return _c('div', {
      staticClass: "input-group"
    }, [_c('div', {
      staticClass: "input-label"
    }, [_vm._v(_vm._s(item.name))]), _vm._v(" "), _c('div', {
      staticClass: "input-field"
    }, [(item.type == 'account') ? _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.login_input_account),
        expression: "login_input_account"
      }],
      attrs: {
        "type": "text",
        "placeholder": item.title
      },
      domProps: {
        "value": (_vm.login_input_account)
      },
      on: {
        "input": [function($event) {
          if ($event.target.composing) { return; }
          _vm.login_input_account = $event.target.value
        }, function($event) {
          return _vm.handleInputEditing(item)
        }]
      }
    }) : _vm._e(), _vm._v(" "), (item.type == 'username') ? _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.login_input_username),
        expression: "login_input_username"
      }],
      attrs: {
        "type": "text",
        "placeholder": item.title
      },
      domProps: {
        "value": (_vm.login_input_username)
      },
      on: {
        "input": [function($event) {
          if ($event.target.composing) { return; }
          _vm.login_input_username = $event.target.value
        }, function($event) {
          return _vm.handleInputEditing(item)
        }]
      }
    }) : _vm._e(), _vm._v(" "), ((_vm.password) === 'checkbox' && (item.type == 'password')) ? _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.login_input_password),
        expression: "login_input_password"
      }],
      attrs: {
        "placeholder": item.title,
        "type": "checkbox"
      },
      domProps: {
        "checked": Array.isArray(_vm.login_input_password) ? _vm._i(_vm.login_input_password, null) > -1 : (_vm.login_input_password)
      },
      on: {
        "input": function($event) {
          return _vm.handleInputEditing(item)
        },
        "change": function($event) {
          var $$a = _vm.login_input_password,
            $$el = $event.target,
            $$c = $$el.checked ? (true) : (false);
          if (Array.isArray($$a)) {
            var $$v = null,
              $$i = _vm._i($$a, $$v);
            if ($$el.checked) {
              $$i < 0 && (_vm.login_input_password = $$a.concat([$$v]))
            } else {
              $$i > -1 && (_vm.login_input_password = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
            }
          } else {
            _vm.login_input_password = $$c
          }
        }
      }
    }) : ((_vm.password) === 'radio' && (item.type == 'password')) ? _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.login_input_password),
        expression: "login_input_password"
      }],
      attrs: {
        "placeholder": item.title,
        "type": "radio"
      },
      domProps: {
        "checked": _vm._q(_vm.login_input_password, null)
      },
      on: {
        "input": function($event) {
          return _vm.handleInputEditing(item)
        },
        "change": function($event) {
          _vm.login_input_password = null
        }
      }
    }) : (item.type == 'password') ? _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.login_input_password),
        expression: "login_input_password"
      }],
      attrs: {
        "placeholder": item.title,
        "type": _vm.password
      },
      domProps: {
        "value": (_vm.login_input_password)
      },
      on: {
        "input": [function($event) {
          if ($event.target.composing) { return; }
          _vm.login_input_password = $event.target.value
        }, function($event) {
          return _vm.handleInputEditing(item)
        }]
      }
    }) : _vm._e(), _vm._v(" "), (item.type == 'code') ? _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.login_input_code),
        expression: "login_input_code"
      }],
      attrs: {
        "type": "text",
        "placeholder": item.title
      },
      domProps: {
        "value": (_vm.login_input_code)
      },
      on: {
        "input": [function($event) {
          if ($event.target.composing) { return; }
          _vm.login_input_code = $event.target.value
        }, function($event) {
          return _vm.handleInputEditing(item)
        }]
      }
    }) : _vm._e()]), _vm._v(" "), (item.name == '验证码:') ? _c('div', {
      staticClass: "code-button",
      class: {
        'active': _vm.canClick, 'disabled': !_vm.canClick
      },
      on: {
        "click": function($event) {
          return _vm.sendCode()
        }
      }
    }, [_vm._v(_vm._s(_vm.code_timer_text))]) : _vm._e(), _vm._v(" "), (item.type == 'password') ? _c('div', {
      staticClass: "show-password",
      on: {
        "click": function($event) {
          return _vm.passwordSee()
        }
      }
    }, [_c('img', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (!_vm.showPassword),
        expression: "!showPassword"
      }],
      attrs: {
        "src": require("./register_nosee.png")
      }
    }), _vm._v(" "), _c('img', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.showPassword),
        expression: "showPassword"
      }],
      attrs: {
        "src": require("./register_see.png")
      }
    })]) : _vm._e()])
  }), _vm._v(" "), _c('div', {
    staticClass: "toast",
    class: {
      'success': _vm.toast_active
    }
  }, [_vm._v(_vm._s(_vm.error_info))]), _vm._v(" "), _c('button', {
    staticClass: "login-button",
    class: {
      'disabled': !_vm.login_normarl_status, 'active': _vm.login_normarl_status
    },
    on: {
      "click": function($event) {
        return _vm.handleLoginButton()
      }
    }
  }, [_vm._v(_vm._s(_vm.login_title))]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isForgotpwd || _vm.login_type_register),
      expression: "isForgotpwd || login_type_register"
    }],
    staticClass: "back-to-login",
    on: {
      "click": function($event) {
        return _vm.gotoLogin()
      }
    }
  }, [_vm._v("返回登录")]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.login_show_protocol),
      expression: "login_show_protocol"
    }],
    staticClass: "protocol-area"
  }, [_c('span', [_vm._v("同意")]), _vm._v(" "), _vm._l((_vm.register_protocol), function(item, index) {
    return _c('a', {
      on: {
        "click": function($event) {
          return _vm.handleProtocol(item)
        }
      }
    }, [_vm._v(_vm._s(item.title))])
  })], 2)], 2)]), _vm._v(" "), _vm._m(2)]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.mask_visible),
      expression: "mask_visible"
    }],
    staticClass: "loading-mask"
  }, [_c('div', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }, {
      name: "show",
      rawName: "v-show",
      value: (_vm.loading),
      expression: "loading"
    }],
    staticClass: "loading-spinner",
    attrs: {
      "element-loading-background": "rgba(0,0,0,0.5)"
    }
  })])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "ai-background"
  }, [_c('div', {
    staticClass: "ai-overlay"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "logo-area"
  }, [_c('div', {
    staticClass: "logo-text"
  }, [_vm._v("AI.EEEUY.COM")]), _vm._v(" "), _c('div', {
    staticClass: "logo-subtitle"
  }, [_vm._v("咿呦动画制作平台")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "features-area"
  }, [_c('div', {
    staticClass: "feature-item"
  }, [_c('div', {
    staticClass: "feature-icon"
  }, [_vm._v("🚀")]), _vm._v(" "), _c('div', {
    staticClass: "feature-title"
  }, [_vm._v("AI智能创作")]), _vm._v(" "), _c('div', {
    staticClass: "feature-desc"
  }, [_vm._v("自研模型库，多种动画风格可选")])]), _vm._v(" "), _c('div', {
    staticClass: "feature-item"
  }, [_c('div', {
    staticClass: "feature-icon"
  }, [_vm._v("🎨")]), _vm._v(" "), _c('div', {
    staticClass: "feature-title"
  }, [_vm._v("丰富的素材库")]), _vm._v(" "), _c('div', {
    staticClass: "feature-desc"
  }, [_vm._v("动作库一键套用，形象库一键制作")])]), _vm._v(" "), _c('div', {
    staticClass: "feature-item"
  }, [_c('div', {
    staticClass: "feature-icon"
  }, [_vm._v("🔄")]), _vm._v(" "), _c('div', {
    staticClass: "feature-title"
  }, [_vm._v("云端创作")]), _vm._v(" "), _c('div', {
    staticClass: "feature-desc"
  }, [_vm._v("随时随地，创作你的作品")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-676efe1e","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Login/Login.vue
// module id = 391
// module chunks = 0